import 'normalize.css';
import 'base.css';

import { MDXProvider } from '@mdx-js/react';
import {
  CallToAction,
  PaycheckCalculator,
  PreviewCallToAction,
  ToolTip,
} from 'components/components-available-to-blog';
import React, { FC, PropsWithChildren } from 'react';

const shortcodes = {
  ToolTip,
  CallToAction,
  PreviewCallToAction,
  PaycheckCalculator,
};

interface LayoutProps {}

const Layout: FC<PropsWithChildren<LayoutProps>> = ({ children }) => (
  <MDXProvider components={shortcodes}>{children}</MDXProvider>
);

export default Layout;
